import { render, staticRenderFns } from "./EmployeeInsert.vue?vue&type=template&id=98f592a6&scoped=true"
import script from "./EmployeeInsert.vue?vue&type=script&lang=js"
export * from "./EmployeeInsert.vue?vue&type=script&lang=js"
import style0 from "./EmployeeInsert.vue?vue&type=style&index=0&id=98f592a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f592a6",
  null
  
)

export default component.exports